import { OrderShipmentRefundSummary } from '../models';
import { OrderShipmentRefundSummaryResponse } from '../api/responses';

export const orderShipmentRefundSummaryFromResponse = (
  response: OrderShipmentRefundSummaryResponse,
): OrderShipmentRefundSummary => {
  return new OrderShipmentRefundSummary({
    fullyRefunded: response.fullyRefunded,
    refundedPrice: response.refundedPrice,
    originalPrice: response.originalPrice,
    currentPrice: response.currentPrice,
    refundedQuantity: response.refundedQuantity,
    currentQuantity: response.currentQuantity,
    originalQuantity: response.originalQuantity,
  });
};
